// The wcBot's model: P(win) = σ(Σ w·x) over the differenced inputs (features.ts). No intercept, so the
// two teams' chances add to 1. The weights are log-odds; WC_START is a hand-set first guess, to be
// replaced by fitted ones (bench fit).

import type { WcFeature } from './features';
import { WC_FEATURES } from './features';

export type WcWeights = Record<WcFeature, number>;

export const WC_START: WcWeights = {
  race1: 3, race2: 2, race3: 1.2, race4: 0.6, race5: 0.3,
  toAct: 0.1, race1Act: 1.5,
  tempo: 0.15,
  carrying: 0.5, carrierRisk: -1.5, unitRisk: -0.3, riskValue: -0.1, flagGuard: 0.2, escort: 0.2,
  advance: 0.3,
  cells: 0.08, swift: 0.15, effects: 0.08, magnet: 0.2,
  jailed: -0.4,
  dom0: 2.5, dom1: 0.8,
  mercy: 1.5,
};

// The weights the site plays with: self-play run n1, round 7 (bench/weights/n1r7.json; see
// bench/selfplay/n1/log.md). Kept here because the bot also runs in the browser.
export const WC_FITTED_NAME = 'n1r7';
export const WC_FITTED: Partial<WcWeights> = { race1: 2.3968, race2: 1.523, race3: 0.8813, race4: 0.5777, race5: 0.375, toAct: 0.0745, race1Act: 0.7842, tempo: 0.1903, carrying: 1.104, carrierRisk: -1.0814, unitRisk: -0.0351, advance: 0, cells: 0.0429, swift: 0, effects: 0, dom0: 1.1728, dom1: 0.5485, mercy: 0 };

export const weightVector = (w: Partial<WcWeights>) => Float64Array.from(WC_FEATURES, k => w[k] ?? WC_START[k]);

export function winChance(x: Float64Array, w: Float64Array): number {
  let z = 0;
  for (let i = 0; i < x.length; i++) z += w[i] * x[i];
  return 1 / (1 + Math.exp(-z));
}
